var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { "data-grm-comp": "RoomCallSpeechText" } }, [
    _c(
      "div",
      {
        staticClass:
          "p-2 rounded-lg select-none pointer-events-none absolute right-4 bottom-5 left-4 text-center text-sm text-white transition-all z-50 call-speech-text",
        class: [
          _vm.stt.show || _vm.translation.text
            ? "bottom-10 opacity-100"
            : "opacity-0",
        ],
      },
      [
        _c("div", [_vm._v(_vm._s(_vm.stt.text))]),
        _c("div", { staticClass: "stt-translation-text" }, [
          _vm._v(_vm._s(_vm.translation.text)),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }